import React from 'react'
import { useTranslation } from 'react-i18next'
import { Card, CardContent, CardHeader, Box, useTheme } from '@mui/material'
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts'

export interface MonthlyTrendData {
  month: string
  completionRate: number
  averageScore: number
}

interface MonthlyTrendChartProps {
  data: MonthlyTrendData[]
}

export const MonthlyTrendChart: React.FC<MonthlyTrendChartProps> = ({ data }) => {
  const { t } = useTranslation('dashboard')
  const theme = useTheme()

  return (
    <Card sx={{ mb: 3 }}>
      <CardHeader
        title={t('monthlyTrend.title', '月別推移')}
        titleTypographyProps={{ variant: 'h6' }}
      />
      <CardContent>
        <Box sx={{ width: '100%', height: 300 }}>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={data} margin={{ top: 5, right: 30, left: 0, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" stroke={theme.palette.divider} />
              <XAxis dataKey="month" tick={{ fill: theme.palette.text.secondary, fontSize: 12 }} />
              <YAxis
                domain={[0, 100]}
                tick={{ fill: theme.palette.text.secondary, fontSize: 12 }}
              />
              <Tooltip
                contentStyle={{
                  backgroundColor: theme.palette.background.paper,
                  border: `1px solid ${theme.palette.divider}`,
                  borderRadius: 8,
                }}
              />
              <Legend />
              <Line
                type="monotone"
                dataKey="completionRate"
                name={t('monthlyTrend.completionRate', '完了率')}
                stroke={theme.palette.primary.main}
                strokeWidth={2}
                dot={{ fill: theme.palette.primary.main, r: 4 }}
                activeDot={{ r: 6 }}
              />
              <Line
                type="monotone"
                dataKey="averageScore"
                name={t('monthlyTrend.averageScore', '平均スコア')}
                stroke={theme.palette.secondary.main}
                strokeWidth={2}
                dot={{ fill: theme.palette.secondary.main, r: 4 }}
                activeDot={{ r: 6 }}
              />
            </LineChart>
          </ResponsiveContainer>
        </Box>
      </CardContent>
    </Card>
  )
}
